export default "__VITE_ASSET__DLdpZJiX__"